import { authStore } from '../stores';
import { Regions } from '@intercom/messenger-js-sdk/dist/types';
import Intercom from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

export const useIntercom = () => {
	const currentUser = authStore.user;
	const intercomAppId = process.env['NEXT_PUBLIC_INTERCOM_APP_ID'];

	useEffect(() => {
		if (currentUser && intercomAppId) {
			Intercom({
				region: process.env['NEXT_PUBLIC_INTERCOM_REGION'] as Regions,
				app_id: intercomAppId,
				name: currentUser.fullName,
				email: currentUser.email,
				user_id: currentUser.id,
			});
			console.log('Intercom initialized successfully for authenticated user');
		}
		if (!currentUser && intercomAppId) {
			Intercom({
				region: process.env['NEXT_PUBLIC_INTERCOM_REGION'] as Regions,
				app_id: intercomAppId,
			});
			console.log('Intercom initialized successfully for unauthenticated user');
		}
	}, [currentUser, intercomAppId]);
};
